import { Navigate, useLocation } from 'react-router-dom';

export const RedirectWithoutTrailingSlash = () => {
  const location = useLocation();
  return <Navigate to={location.pathname.slice(0, -1)} replace />;
};

export default RedirectWithoutTrailingSlash;